import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { deleteMahdoodeFani, getMahdoodeFani } from "Stores/actions";
import * as Icons from 'react-bootstrap-icons';

function MahdoodeFaniDeleteRow({ row }) {
  const {
    selectedBazsho,
    mahdoodeFaniPagination,
  } = useSelector((state) => ({
    selectedBazsho: state.yaragh.selectedBazsho,
    mahdoodeFaniPagination: state.yaragh.mahdoodeFaniPagination,
  }));
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteMahdoodeFani(data));
      if (res) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdPop: +selectedBazsho.Id,
          Limit: mahdoodeFaniPagination.Limit,
          Page: mahdoodeFaniPagination.Page,
        };
        await dispatch(getMahdoodeFani(params));
        handleDialog();
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={handleDialog}
        disabled={row.IsG && read("StypeU") !== "1"}
      />
      <AlertDialog
        showAlert={openDialog}
        type="alertError"
        onClose={handleDialog}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        loading={loading}
      />
    </>
  );
}
export default MahdoodeFaniDeleteRow;
